import { EMAIL_REGEXP } from '@myre/common-primitives';

import { type AbstractControl, type ValidationErrors } from '@angular/forms';

import { type QuestionValidator } from './interfaces';

export function emailValidator(): QuestionValidator {
  return (_: AbstractControl, value: string): ValidationErrors | null => {
    return !value || EMAIL_REGEXP.test(value)
      ? null
      : {
          '_system.errorEmailInvalid': {
            valid: false,
          },
        };
  };
}
